export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11742.7b1c37ef.jpg";